import ReactMarkdown from 'react-markdown';

const MARKDOWN_COMPONENTS = {
  h1: ({ node, ...props }: any) => (
    <h1 className="text-xl font-bold mt-6 mb-3 first:mt-0 text-gray-800 dark:text-gray-100" {...props} />
  ),
  h2: ({ node, ...props }: any) => (
    <h2 className="text-lg font-bold mt-5 mb-3 first:mt-0 text-gray-800 dark:text-gray-100" {...props} />
  ),
  h3: ({ node, ...props }: any) => (
    <h3 className="text-base font-semibold mt-4 mb-2 first:mt-0 text-gray-800 dark:text-gray-100" {...props} />
  ),
  p: ({ node, ...props }: any) => (
    <p className="mb-4 last:mb-0 text-gray-800 dark:text-gray-100" {...props} />
  ),
  ul: ({ node, ...props }: any) => (
    <ul className="list-disc list-inside mb-4 space-y-2 text-gray-800 dark:text-gray-100" {...props} />
  ),
  ol: ({ node, ...props }: any) => (
    <ol className="list-decimal list-inside mb-4 space-y-2 text-gray-800 dark:text-gray-100" {...props} />
  ),
  li: ({ node, ...props }: any) => (
    <li className="ml-2 mb-1 text-gray-800 dark:text-gray-100" {...props} />
  ),
  strong: ({ node, ...props }: any) => (
    <strong className="font-semibold text-gray-900 dark:text-gray-100" {...props} />
  ),
  a: ({ node, ...props }: any) => (
    <a className="text-pink-600 dark:text-pink-400 underline hover:text-pink-700" target="_blank" rel="noopener noreferrer" {...props} />
  ),
  code: ({ node, inline, ...props }: any) =>
    inline ? (
      <code className="bg-gray-200 dark:bg-gray-700 px-1 py-0.5 rounded text-xs text-gray-900 dark:text-gray-100" {...props} />
    ) : (
      <code className="block bg-gray-200 dark:bg-gray-700 p-2 rounded text-xs overflow-x-auto text-gray-900 dark:text-gray-100" {...props} />
    ),
};

export { MARKDOWN_COMPONENTS };

interface MarkdownContentProps {
  content: string;
  className?: string;
}

export default function MarkdownContent({ content, className }: MarkdownContentProps) {
  return (
    <div className={className ?? "text-base leading-relaxed prose prose-base max-w-none prose-headings:text-gray-800 dark:prose-headings:text-gray-100 prose-p:text-gray-800 dark:prose-p:text-gray-100 prose-strong:text-gray-900 dark:prose-strong:text-gray-100 prose-ul:text-gray-800 dark:prose-ul:text-gray-100 prose-ol:text-gray-800 dark:prose-ol:text-gray-100 prose-li:text-gray-800 dark:prose-li:text-gray-100 prose-a:text-pink-600 dark:prose-a:text-pink-400 prose-a:underline hover:prose-a:text-pink-700"}>
      <ReactMarkdown components={MARKDOWN_COMPONENTS}>
        {content}
      </ReactMarkdown>
    </div>
  );
}
